/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';

const ShowTipoSoggetto = ({ soggetto, extraClassName }) => {

    if (soggetto !== null && soggetto !== undefined && (soggetto.isProspect || soggetto.isCliente || soggetto.isFornitore || soggetto.isTp))
    {
        let rv1 = null;
        let rv2 = null;
        let rv3 = null;
        let rv4 = null;
        if (soggetto.isProspect)
        {
            rv4 = <div className={"ui orange label " + extraClassName}>prospect</div>
        }
        if (soggetto.isCliente)
        {
            rv1 = <div className={"ui green label " + extraClassName}>cliente</div>
        }
        if (soggetto.isFornitore)
        {
            rv2 = <div className={"ui yellow label " + extraClassName}>fornitore</div>
        }
        if (soggetto.isTp)
        {
            rv3 = <div className={"ui brown label " + extraClassName}>terze parti</div>
        }
        return <span>{rv4}{rv1}{rv2}{rv3}</span>;
    }
    else{
        return null
    }
}

export default ShowTipoSoggetto;


/** WEBPACK FOOTER **
 ** ./src/components/rubrica/ShowTipoSoggetto.jsx
 **/